var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "related-products" },
    [
      "mobile" !== _vm.$mq
        ? _c("icon-button", {
            staticClass: "related-products__prev",
            attrs: {
              label: "Next Slide",
              icon: "chevron-left-big",
              size: "64px",
            },
            on: {
              click: function ($event) {
                return _vm.$refs.productImageCarousel.slidePrev()
              },
            },
          })
        : _vm._e(),
      "mobile" !== _vm.$mq
        ? _c("icon-button", {
            staticClass: "related-products__next",
            attrs: {
              label: "Previous Slide",
              icon: "chevron-right-big",
              size: "64px",
            },
            on: {
              click: function ($event) {
                return _vm.$refs.productImageCarousel.slideNext()
              },
            },
          })
        : _vm._e(),
      _c(
        "carousel",
        {
          ref: "productImageCarousel",
          attrs: {
            infinite: true,
            "center-mode": true,
            dots: ["mobile", "tablet"].includes(_vm.$mq),
            "slides-to-show": ["mobile", "tablet"].includes(_vm.$mq) ? 1.5 : 3,
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }